__turbopack_context__.v({
  "image": "Media-module-scss-module__aYXSaq__image",
  "imageContainer": "Media-module-scss-module__aYXSaq__imageContainer",
  "video": "Media-module-scss-module__aYXSaq__video",
  "videoContainer": "Media-module-scss-module__aYXSaq__videoContainer",
  "wrapper": "Media-module-scss-module__aYXSaq__wrapper",
});
